// In-line destructuring syntax in an import statement when using ES Modules spec:
// 1) declaring a variable with the name in the { } - object desstructuring - so that if that name in the { } matches the name of a prop on the object it is pointing at (i.e. the namespace object on the file path we include after the from key word!) - we will succesfully hook into object literals short hand syntax in javascript 
// 2) and assign the value of that newly declared variable to be the value of the eponymously named property on the object it is pointing atimport { useAPI } from './useAPI.js';
import { useDashBaseAPI } from "./api/clients/useBaseAPI.js";

export const useCompsAPI = () => {
  const comps = useDashBaseAPI("/comps");
  
  const getCategories = async () => {
    const response = await comps.get("/categories");
    return response;
  };
  
  const getCosForCategory = async (payload) => {
    const response = await comps.post("/cos-for-category", payload);
    return response;
  };
  
  return {
    getCategories,
    getCosForCategory
  };
};
